// @flow

type checkCurrentItemAddedQtyParams = {
  currentItem: any,
  activeOrderDet: any,
};

const getCurrentItemAddedQty = ({
  currentItem,
  activeOrderDet,
}: checkCurrentItemAddedQtyParams) => {
  return currentItem
    ? activeOrderDet
        .filter(
          i =>
            i.Code === currentItem.Code &&
            Array.isArray(i.MoboQty) && i.MoboQty.some(a => a.OrderNoMobo === currentItem.OrderNo),
        )
        .reduce((reducer, i) => {
          const item = Array.isArray(i.MoboQty) && i.MoboQty.find(a => a.OrderNoMobo === currentItem.OrderNo);

          if (item) {
            reducer += item.Qty;
          }

          return reducer;
        }, 0)
    : 0;
};

export { getCurrentItemAddedQty };
